var _rect, _rect2, _mask, _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgScales28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.84377,
    y: 5.23955,
    width: 5.4375,
    height: 0.604167,
    stroke: "currentColor",
    strokeWidth: 0.604167
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7188,
    y: 5.23955,
    width: 5.4375,
    height: 0.604167,
    stroke: "currentColor",
    strokeWidth: 0.604167
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_4485_72937",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0416 25.4791C20.0416 24.6857 19.8854 23.9001 19.5818 23.1671C19.2781 22.4341 18.8331 21.7681 18.2721 21.207C17.7111 20.646 17.045 20.201 16.312 19.8974C15.579 19.5938 14.7934 19.4375 14 19.4375C13.2066 19.4375 12.4209 19.5938 11.6879 19.8974C10.9549 20.201 10.2889 20.646 9.72788 21.207C9.16686 21.7681 8.72183 22.4341 8.41821 23.1671C8.11459 23.9001 7.95831 24.6857 7.95831 25.4791L20.0416 25.4791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7917 8.56247H15.2083V20.7318H12.7917V8.56247Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0416 25.4791L20.0416 27.8958L22.4583 27.8958V25.4791H20.0416ZM14 19.4375L14 21.8541L14 19.4375ZM7.95831 25.4791L5.54165 25.4791L5.54165 27.8958L7.95831 27.8958L7.95831 25.4791ZM12.7917 8.56247V6.1458H10.375V8.56247H12.7917ZM15.2083 8.56247H17.625V6.1458H15.2083V8.56247ZM15.2083 20.7318V23.1484H17.625V20.7318H15.2083ZM12.7917 20.7318H10.375V23.1484H12.7917V20.7318ZM22.4583 25.4791C22.4583 24.3684 22.2395 23.2685 21.8145 22.2423L17.349 24.0919C17.5312 24.5317 17.625 25.0031 17.625 25.4791H22.4583ZM21.8145 22.2423C21.3894 21.2161 20.7664 20.2836 19.9809 19.4982L16.5632 22.9159C16.8999 23.2525 17.1669 23.6521 17.349 24.0919L21.8145 22.2423ZM19.9809 19.4982C19.1955 18.7128 18.2631 18.0897 17.2368 17.6647L15.3872 22.1301C15.827 22.3123 16.2266 22.5793 16.5632 22.9159L19.9809 19.4982ZM17.2368 17.6647C16.2106 17.2396 15.1107 17.0208 14 17.0208L14 21.8541C14.476 21.8541 14.9474 21.9479 15.3872 22.1301L17.2368 17.6647ZM14 17.0208C12.8892 17.0208 11.7893 17.2396 10.7631 17.6647L12.6128 22.1301C13.0526 21.9479 13.5239 21.8541 14 21.8541L14 17.0208ZM10.7631 17.6647C9.7369 18.0897 8.80446 18.7128 8.01903 19.4982L11.4367 22.9159C11.7733 22.5793 12.1729 22.3123 12.6128 22.1301L10.7631 17.6647ZM8.01903 19.4982C7.23361 20.2836 6.61057 21.2161 6.1855 22.2423L10.6509 24.0919C10.8331 23.6521 11.1001 23.2525 11.4367 22.9159L8.01903 19.4982ZM6.1855 22.2423C5.76043 23.2685 5.54165 24.3684 5.54165 25.4791L10.375 25.4791C10.375 25.0031 10.4687 24.5317 10.6509 24.0919L6.1855 22.2423ZM12.7917 10.9791H15.2083V6.1458H12.7917V10.9791ZM12.7917 8.56247V20.7318H17.625V8.56247H12.7917ZM15.2083 18.3151H12.7917V23.1484H15.2083V18.3151ZM15.2083 20.7318V8.56247H10.375V20.7318H15.2083ZM7.95831 27.8958L20.0416 27.8958L20.0416 23.0625L7.95831 23.0625L7.95831 27.8958Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-1_4485_72937)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 13.3958C10.375 14.0305 10.25 14.6591 10.0071 15.2455C9.76417 15.8319 9.40815 16.3647 8.95933 16.8135C8.51051 17.2623 7.97769 17.6183 7.39128 17.8612C6.80488 18.1041 6.17637 18.2292 5.54165 18.2292C4.90692 18.2292 4.27842 18.1041 3.69201 17.8612C3.1056 17.6183 2.57278 17.2623 2.12396 16.8135C1.67515 16.3647 1.31913 15.8319 1.07623 15.2455C0.833331 14.6591 0.708313 14.0305 0.708313 13.3958L5.54165 13.3958H10.375Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 6.14581,
    r: 2.41667,
    stroke: "currentColor",
    strokeWidth: 2.41667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74941 12.7916L5.54172 6.1552L9.33392 12.7916H1.74941Z",
    stroke: "currentColor",
    strokeWidth: 1.20833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2917 13.3958C27.2917 14.0305 27.1666 14.6591 26.9238 15.2455C26.6809 15.8319 26.3248 16.3647 25.876 16.8135C25.4272 17.2623 24.8944 17.6183 24.308 17.8612C23.7216 18.1041 23.0931 18.2292 22.4583 18.2292C21.8236 18.2292 21.1951 18.1041 20.6087 17.8612C20.0223 17.6183 19.4895 17.2623 19.0407 16.8135C18.5918 16.3647 18.2358 15.8319 17.9929 15.2455C17.75 14.6591 17.625 14.0305 17.625 13.3958L22.4583 13.3958H27.2917Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6661 12.7916L22.4584 6.1552L26.2506 12.7916H18.6661Z",
    stroke: "currentColor",
    strokeWidth: 1.20833
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScales28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;